export const auditRequests = (requestor: any) => ({
  getLogs: async (params: {
    page?: number;
    limit?: number;
    category?: string;
    role?: string;
    status?: string;
    search?: string;
    dateFrom?: string;
    dateTo?: string;
  }) => {
    const query = Object.entries(params)
      .filter(([, v]) => v !== '' && v !== undefined && v !== null)
      .map(([k, v]) => `${k}=${encodeURIComponent(v as string)}`)
      .join('&');
    return requestor({ method: 'GET', url: `/audit-logs${query ? `?${query}` : ''}` });
  },

  getStats: async () => requestor({ method: 'GET', url: '/audit-logs/stats' }),
});
